import { Component, EventEmitter, Input, Output } from '@angular/core';
import { BlockHeaderGroup } from '@interfaces/block-header-group';
import { IconComponent } from '../../../shared/components/icon/icon.component';
import { NgIf, NgFor, NgClass } from '@angular/common';

@Component({
    selector: 'app-block-header',
    templateUrl: './block-header.component.html',
    styleUrls: ['./block-header.component.scss'],
    standalone: true,
    imports: [NgIf, NgFor, NgClass, IconComponent]
})
export class BlockHeaderComponent {
    @Input() header: string;
    @Input() arrows = false;
    @Input() groups: BlockHeaderGroup[] = [];

    @Output() next: EventEmitter<any> = new EventEmitter();
    @Output() prev: EventEmitter<any> = new EventEmitter();

    @Output() groupChange: EventEmitter<BlockHeaderGroup> = new EventEmitter();

    constructor() { }

    setGroup(group: BlockHeaderGroup): void {
        this.groups.forEach(g => g.current = g === group);
        this.groupChange.emit(group);
    }
}
